import AOS from 'aos';
// import 'aos/dist/aos.css'

// -----------------------------------------------------------------------------
// Article sliders -- Remove unused versions
// -----------------------------------------------------------------------------
// import './modules/article-feed-v1'
// import './modules/article-feed-v4'
// import './modules/article-feed-v5'
// -----------------------------------------------------------------------------
// Hero slider component
// -----------------------------------------------------------------------------
// import './modules/page-header-slider-v2.js'
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// Main navigation / NavBar
// -----------------------------------------------------------------------------
import './modules/navbar';
// import './modules/navbar-search'
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// Partners slider -- Remove unused versions
// -----------------------------------------------------------------------------
// import './modules/partner-slider-v1'
// import './modules/partner-slider-v2'
// -----------------------------------------------------------------------------
// Product slider -- Remove unused versions
// -----------------------------------------------------------------------------
// import './modules/product-slider-v1'
// -----------------------------------------------------------------------------
// Recipe slider -- Remove unused versions
// -----------------------------------------------------------------------------
// import './modules/recipe-slider-v1'
// import './modules/recipe-slider-v2'
// -----------------------------------------------------------------------------
// Recipe slider
// -----------------------------------------------------------------------------
import './modules/video';
// -----------------------------------------------------------------------------
// Social feed slider -- Remove unused versions
// -----------------------------------------------------------------------------
// import './modules/social-feed-v1'
// import './modules/social-feed-v2'
// import './modules/social-feed-v3'

// -----------------------------------------------------------------------------
// Lipton
// -----------------------------------------------------------------------------
import './modules/nav-slider';
import './modules/product-slider';
import './modules/kombucha-slider';
import './modules/kombucha-benefits-slider';
import './modules/teaser-card-slider';
import './modules/category-slider';
import './modules/homepage-video';
import './modules/share-comp';
import './modules/faq-slider';
import './modules/sun-header';
// import './modules/quiz'
import './modules/back-to-top';
import './modules/product-single-buy-now-bottom';
import './modules/product-single-sizes-slider';
import './modules/load-more';
import './modules/timeline-animation';
import './modules/page-loader';
import './modules/info-graphic';
import './modules/scroll-to-element';
import './modules/gtm-tracking';
window.IS_QUIZ_RESULT = false;


import './modules/activation-campaign-step1-slider';
import './modules/centered-video-carousel';

// -----------------------------------------------------------------------------
// Summer Promo
// -----------------------------------------------------------------------------

import './summer-promo/summer-promo-global';
import './summer-promo/summer-promo-countdown-page';
import './summer-promo/summer-promo-game-page';
import './summer-promo/summer-promo-registration-page';
import './summer-promo/summer-promo-landing-page';

// -----------------------------------------------------------------------------
// Bus page
// -----------------------------------------------------------------------------
import './bus-page/bus-gallery-sec';

//
AOS.init({
  startEvent: 'load',
  offset: 200,
  delay: 20,
});


// ----- Fix layout shift for all browsers on mac OS --------
document.addEventListener("DOMContentLoaded", function() {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0; // Check if OS is macOS

  if (isMac) {
    document.documentElement.classList.add('macos');
  }
});
// ----- Fix layout shift for all browsers on mac OS --------



// Helper function to get market from URL
function getMarketFromUrl() {
  const urlPath = window.location.pathname;
  const marketMatch = urlPath.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/);
  return marketMatch ? marketMatch[1] : 'default-market';
}

window.getMarketFromUrl = getMarketFromUrl;



